<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-7 mt">
                  <pr-input-column
                    label="Caisse d'affiliation"
                    [derrors]="derrors"
                  >
                    <mat-select #select formControlName="enrollmentOffice">
                      @for (
                        enrollmentOffice of enrollmentOffices;
                        track enrollmentOffice
                      ) {
                        <mat-option [value]="enrollmentOffice.id">
                          {{ enrollmentOffice.value }}
                        </mat-option>
                      }
                    </mat-select>
                  </pr-input-column>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
